import React, { forwardRef, useEffect, useState } from "react";
import { makeStyles, Container, Grid } from "@material-ui/core";
import LaborGalleryFile from "./LaborGalleryFile";


const useStyles = makeStyles((theme) => ({
  viewFileList: {
    borderTop: "1px solid rgb(204, 204, 204)",
    borderBottom: "1px solid rgb(204, 204, 204)",
    padding: 16,
  },
}));

interface LaborGalleryFileListProps {
  fileArray: any;
}

function LaborGalleryFileList({ fileArray }: LaborGalleryFileListProps) {
  const classes = useStyles();
  const [fileList, setFileList] = useState<any>(null);

  useEffect(() => {
    setFileList(fileArray);
    return () => {};
  }, [fileArray]);
  if (fileList && fileList.length > 0) {

    return (
      <Grid xs={12} item className={classes.viewFileList}>
        {fileList.map((file: any, index: any) => {
          return (
            <LaborGalleryFile
              file={file}
              key={`citzen-filelist-${file.name}-${index}`}
            />
          );
        })}
      </Grid>
    );
  } else {
    return <div></div>;
  }
}

export default LaborGalleryFileList;
